module.exports = __webpack_public_path__ + "static/hollyphant-bd6e751775ab24724b43a23d0653b240.jpeg";